import { render, staticRenderFns } from "./VehicleActualRoute.vue?vue&type=template&id=13bd4914"
import script from "./VehicleActualRoute.vue?vue&type=script&lang=js"
export * from "./VehicleActualRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports